__turbopack_context__.v({
  "card": "_2s9KCG_card",
  "content": "_2s9KCG_content",
  "divider": "_2s9KCG_divider",
  "offer-divider": "_2s9KCG_offer-divider",
  "offer-icon": "_2s9KCG_offer-icon",
  "offer-item": "_2s9KCG_offer-item",
  "paymentOffers": "_2s9KCG_paymentOffers",
  "taxInfo": "_2s9KCG_taxInfo",
  "totalRow": "_2s9KCG_totalRow",
});
